import {createRouter, createWebHistory} from 'vue-router'
import HomeView from '../views/HomeView.vue'
import AuthView from '../views/AuthView.vue'
import UserView from '../views/UserView.vue'
import CpView from '../views/CpView.vue'
import TranslationsView from '../views/cp/TranslationsView.vue'
import SettingsView from '../views/cp/SettingsView.vue'
import {useUserStore} from '@/stores/user'
import {CardsMode} from '@/lib/cards-mode'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView,
    },
    {
      path: '/auth',
      name: 'auth',
      component: AuthView,
    },
    {
      path: '/user',
      name: 'user',
      component: UserView,
    },
    {
      path: '/cp',
      name: 'cp',
      component: CpView,
      children: [
        {
          path: 'translations',
          name: 'cp-translations',
          component: TranslationsView,
        },
        {
          path: 'settings',
          name: 'cp-settings',
          component: SettingsView,
        },
        {
          path: 'tts-settings',
          name: 'cp-tts-settings',
          component: () => import('../views/cp/TtsSettingsView.vue'),
        },
        {
          path: 'users',
          name: 'cp-users',
          component: () => import('../views/cp/UsersView.vue'),
        },
        {
          path: 'next',
          redirect: '/cp/next/cards',
        },
        {
          path: 'next/:section(concepts|entities|cards)/:itemId?',
          name: 'cp-next-catalog',
          component: () => import('../views/cp/NextCatalogView.vue'),
        },
      ],
    },
    {
      path: '/cards/studying-cards',
      name: 'cards-studying-cards',
      component: () => import('../views/StudyingCardsView.vue'),
    },
    {
      path: '/cards/:mode/:level?/:unit?',
      name: 'cards',
      component: () => import('../views/CardsView.vue'),
      props: true,
    },
  ],
})

router.beforeEach(async (to) => {
  if (to.path.startsWith('/cards')) {
    const userStore = useUserStore()
    try {
      if (!userStore.user) await userStore.fetchUser()
      if (!userStore.profile) await userStore.fetchProfile().catch(() => {})
    } catch {
      return {name: 'auth'}
    }
    if (!userStore.profile) {
      // wait a tick for profile load if isLoading
      if (userStore.isLoading) {
        await new Promise((r) => setTimeout(r, 300))
      }
      if (!userStore.profile) return {name: 'user'}
    }
    if (to.name === 'cards-studying-cards' && to.query.source !== 'next') {
      return {name: 'cards-studying-cards', query: {...to.query, source: 'next'}}
    }
    if (
      to.name !== 'cards-studying-cards' &&
      ![CardsMode.Listen, CardsMode.Translate].includes(to.params.mode as 'listen' | 'translate')
    ) {
      return {name: 'home'}
    }
    return true
  }
  if (!to.path.startsWith('/cp')) return true

  const userStore = useUserStore()
  try {
    if (!userStore.user) await userStore.fetchUser()
  } catch {
    return {name: 'auth'}
  }

  if (!userStore.user || !['manager', 'admin'].includes(userStore.user.role)) {
    return {name: 'user'}
  }

  return true
})

export default router
